module.exports = __webpack_public_path__ + "/images/constructor-hiw.it.cf5188a.jpg";